<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{ "MasterData.CreateFiscalYear.Title" | i18nextEager }}</ng-template>

  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg">
        <!-- TODO: min value-->

        <doka-number-input formControlName="year" [label]="'MasterData.CreateFiscalYear.Year' | i18nextEager" />

        <app-input-date-picker
          formControlName="latestPlanSubmissionDate"
          [labelText]="'MasterData.CreateFiscalYear.LatestPlanSubmissionDate' | i18nextEager"
        />
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">{{
          "Common.Cancel" | i18nextEager
        }}</doka-button>
        <doka-button type="submit" [disabled]="form.invalid || isLoading()" (click)="submit()" color="primary">{{
          "Common.Save" | i18nextEager
        }}</doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
